import { resolvedAuthMode } from '../../config/runtime';
import type { AuthProvider } from './types';
import { LocalAuthProvider } from './local-provider';
import { SupabaseAuthProvider } from './supabase-provider';

export const authProvider: AuthProvider = resolvedAuthMode === 'supabase'
  ? new SupabaseAuthProvider()
  : new LocalAuthProvider();
